import TransitApi from './base'

export default {
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/carrier/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getBasicList() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/carrier/basic-list')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/carrier/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/carrier/details/${params.id}` : '/carrier/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/carrier/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
